// extracted by mini-css-extract-plugin
module.exports = {"heroWrapper":"Hero_heroWrapper__5MWHZ","hero":"Hero_hero___KI-N","light":"Hero_light__1P5T2","primary":"Hero_primary__1eNBY","dark":"Hero_dark__jyrKf"};